__turbopack_context__.v({
  "className": "_4hFpQa_className",
  "variable": "_4hFpQa_variable",
});
